import { render, staticRenderFns } from "./FeeConfigDialog.vue?vue&type=template&id=75a64536&scoped=true"
import script from "./FeeConfigDialog.vue?vue&type=script&lang=js"
export * from "./FeeConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./FeeConfigDialog.vue?vue&type=style&index=0&id=75a64536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a64536",
  null
  
)

export default component.exports